import { useReveal } from '../hooks/useReveal'
export default function ScrollReveal({
  children,
  as: Tag = 'div',
  delay = 0,
  direction = 'up',
  className = '',
  ...rest
}) {
  const [ref, visible] = useReveal()

  return (
    <Tag
      ref={ref}
      className={`reveal reveal-${direction} ${visible ? 'is-visible' : ''} ${className}`}
      style={{ transitionDelay: visible ? `${delay}ms` : '0ms' }}
      {...rest}
    >
      {children}
    </Tag>
  )
}
